import { useQuery } from "@tanstack/react-query";
import { journalsQueries } from "@/entities/journal";
import { mapResponsibleToCards, mapSignersToCards } from "./map-personnel-data";
import type { JournalPersonnelDataParams } from "./types";

const getSignersQuery = (sectionType: JournalPersonnelDataParams["sectionType"], sectionId: string) => {
  switch (sectionType) {
    case "sectionOne":
      return journalsQueries.getSectionOneSignersList(sectionId);
    case "sectionTwo":
      return journalsQueries.getSectionTwoSignersList(sectionId);
    case "sectionThree":
      return journalsQueries.getSectionThreeSignersList(sectionId);
    case "sectionFour":
      return journalsQueries.getSectionFourSignersList(sectionId);
    default:
      return journalsQueries.getSectionOneSignersList(sectionId);
  }
};

const getResponsibleQuery = (
  sectionType: JournalPersonnelDataParams["sectionType"],
  sectionId: string,
) => {
  switch (sectionType) {
    case "sectionOne":
      return journalsQueries.getResponsibleCommentListFirstOne(sectionId);
    case "sectionTwo":
      return journalsQueries.getResponsibleCommentListSecondOne(sectionId);
    case "sectionThree":
      return journalsQueries.getResponsibleCommentListThirdOne(sectionId);
    case "sectionFour":
      return journalsQueries.getResponsibleCommentListFourthOne(sectionId);
    default:
      return journalsQueries.getResponsibleCommentListFirstOne(sectionId);
  }
};

export const useSectionPersonnelData = ({
  sectionType,
  sectionId,
}: JournalPersonnelDataParams) => {
  const enabled = Boolean(sectionId);

  const signersQuery = getSignersQuery(sectionType, sectionId || "");
  const responsibleQuery = getResponsibleQuery(sectionType, sectionId || "");

  const {
    data: signersData,
    isPending: isSignersPending,
    isFetching: isSignersFetching,
  // @ts-expect-error union query options по типу раздела
  } = useQuery({
    ...signersQuery,
    enabled,
  });

  const {
    data: responsibleData,
    isPending: isResponsiblePending,
    isFetching: isResponsibleFetching,
  // @ts-expect-error union query options по типу раздела
  } = useQuery({
    ...responsibleQuery,
    enabled,
  });

  const signers = (signersData as { signers?: unknown[] } | undefined)?.signers;
  const signatoryCards = mapSignersToCards(signers as any[] | undefined);
  const responsibleCards = mapResponsibleToCards(
    responsibleData as Record<string, any[] | undefined> | undefined,
    sectionType,
  );

  return {
    signatoryCards,
    responsibleCards,
    isLoading:
      isSignersPending ||
      isResponsiblePending ||
      isSignersFetching ||
      isResponsibleFetching,
  };
};
